import {
  Button,
  ButtonSize,
  ButtonVariant,
} from "@amzn/stencil-react-components/button";
import { trackStructEvent } from "@snowplow/browser-tracker";
import React, { useContext } from "react";
import { FormattedMessage, useIntl } from "react-intl";

import { CHAT_SUPPORT_CONTEXTS_METRICS_MAP } from "@/components/GetSupport/ChatWithITSupport/constants";
import { isSelfHelpEnabled } from "@/helpers/faq-helper";
import { AppContext } from "@/stores/appStore";
import { ActionType } from "@/stores/constants";
import { Day1EventAction, Day1EventCategory } from "@/types/snowplow-events";

export const GetSupportHeaderLink = (): JSX.Element => {
  const { state, dispatch } = useContext(AppContext);
  const intl = useIntl();
  // Handles clicking on the component.
  const openHandler = () => {
    // If step has FAQ enabled, then we show FAQ instead of chat support.
    if (isSelfHelpEnabled(state.currentStep?.id)) {
      trackStructEvent({
        category: Day1EventCategory.PageLevel,
        action: Day1EventAction.ShowSelfHelpFAQ,
        label: state.currentStep?.id,
      });
    } else if (state.nonDirectedChatSupportContext) {
      // If there is non directed support context, track the metric. This should generally be the case but this component
      // is not responsible for setting the support context, so it may not be set yet.
      const { category, action, label } =
        CHAT_SUPPORT_CONTEXTS_METRICS_MAP[state.nonDirectedChatSupportContext];
      trackStructEvent({
        category,
        action,
        label,
      });
      dispatch({
        type: ActionType.SET_CHAT_SUPPORT_REF_LINK,
        chatSupportRefLink: "ezo-chat",
      });
    }

    // Set flyout visibility
    dispatch({
      type: ActionType.SET_GET_SUPPORT_FLYOUT_VISIBLE,
      getSupportFlyoutVisible: true,
    });
  };

  return (
    <Button
      dataTestId={"getSupportHeaderLink"}
      onClick={openHandler}
      variant={ButtonVariant.Secondary}
      size={ButtonSize.Small}
      aria-label={intl.formatMessage({
        id: "arialabels-clickToOpenGetSupport",
      })}
    >
      <FormattedMessage id="getSupport-header" />
    </Button>
  );
};
